import { GlobalServices } from './services/global.service';
import { AppComponent } from './app.component';

import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { Injector, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ssApiService } from './services/ss-api.service';

import { AuthGuardService } from 'app/services/auth.guard.service';

import { OrderModule } from './order/order.module';
import { AccountModule } from './account/account.module';
import { LoginAsMemberModule } from 'app/login.as.member/login.as.member.module';

import { PlaygroundModule } from 'app/_playground/playground.module';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';

import { AuthenticationModule } from './authentication/authentication.module';
import { SupportTicketsModule } from './support-tickets/support-tickets.module';

import { AppRoutingModule } from './app.routing.module';
import { SharedAppModule } from './app.module.shared';
import { RouterModule } from '@angular/router';
import { MainComponent } from './views/main/main.component';
import { GlobalsComponent } from './debug/globals/globals.component';
import { LoginFromSoftwareModule } from './login.from.software/login.from.software.module';


@NgModule({
    bootstrap: [MainComponent],
    declarations: [

        GlobalsComponent,
        AppComponent

    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        RouterModule,
        SharedAppModule,

        AuthenticationModule,
        SupportTicketsModule,

        OrderModule,
        AccountModule,
        LoginAsMemberModule,
        LoginFromSoftwareModule,

        // DEV PLAYGROUND MODULE
        PlaygroundModule,

        BsDropdownModule.forRoot(),
        TimepickerModule.forRoot(),
        DatepickerModule.forRoot(),

        // routes
        AppRoutingModule, // leave at last for ** redirect

    ],
    providers: [
        { provide: 'ORIGIN_URL', useValue: location.origin },
        // { provide: ErrorHandler, useClass: AppErrorHandler },
        ssApiService,
        GlobalServices,
        AuthGuardService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
    static injector: Injector;
    constructor(injector: Injector) {
        AppModule.injector = injector;
    }
}
